module.exports = __webpack_public_path__ + "media/images/v2/header-1-c025bbae88d9b9ead92cc9332be01362.png";